/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */
// NOTE: do NOT import 'altcha' here. front.js loads on every non-landing page
// (incl. the contact page) and already registers the <altcha-widget> element.
// Importing it again would call customElements.define() twice and throw.

/**
 * Import modules / classes
 */
import MapLoader from "./modules/MapLoader";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const mapLoader = new MapLoader();
});
